// Utilities
import { qs, cls } from "./util/dom-utils";
import Parallax from "parallax-js";

class SectionCta {
	constructor(el) {
		this.$el = el;
		this.attachEvents();
	}

	curtainsHandler(event, direction) {

		if (event === 'remove') {

			if (direction === 'up-leave') {
				cls.remove(this.$el, 'is-curtain-visible');
			}
			else {
				cls.add(this.$el, 'is-curtain-relative');
			}
		}
		else {
			cls.add(this.$el, 'is-curtain-visible');
			cls.remove(this.$el, 'is-curtain-relative');
		}

	}

	observerScroll() {

		let event = '';

		if ('IntersectionObserver' in window) {

			let options = {
				root: null,
				rootMargin: "10px",
				threshold: [0, 0.15, 0.5, 0.95, 1]
			};

			let previousY, previousRatio, direction;

			const observerCta = new IntersectionObserver((entries, observer) => {
				const el = entries[0];
				// console.log(el.isIntersecting, el.intersectionRatio)

				const currentY = el.boundingClientRect.y;
				const currentRatio = el.intersectionRatio;
				const isIntersecting = el.isIntersecting;

				// Scrolling down/up
				if (currentY < previousY) {
					direction = 'down';

					if (currentRatio > previousRatio && isIntersecting) {
						direction = 'down-enter';
					} else {
						direction = 'down-leave';
					}

				} else if (currentY > previousY && isIntersecting) {
					direction = 'up';

					if (currentRatio < previousRatio) {
						direction = 'up-leave';
					} else {
						direction = 'up-enter';
					}

				}

				previousY = currentY;
				previousRatio = currentRatio;


				event = (el.isIntersecting && el.intersectionRatio >= 0.5) ? 'enter' : 'remove';

				// event = (el.isIntersecting) ? 'enter' : 'remove';


				this.curtainsHandler(event, direction);

			}, options);

			// Start observing 
			observerCta.observe(this.$el);



		}

	}

	attachEvents() {

		if(!window.Modernizr.touch) {
			const cinemaSvg = qs(".item-svg-cinema", this.$el);

			this.parallaxInstance = new Parallax(cinemaSvg, {
				selector: ".svg__layer"
			});
		}
		

		this.observerScroll();

	}

}

export default SectionCta;

const _init = () => {

	// Elements
	let $el = qs('.section-cta');

	if ($el) {
		new SectionCta($el);
	}
};

_init();
